module.exports = __webpack_public_path__ + "img/IN.082356ca.svg";